import { reaction } from 'mobx'
import { type EditorView } from 'prosemirror-view'
import { getTrackChangesState } from './constants'
import { State } from './Types'
import { QueryClient } from 'react-query'

export class TrackChangesView {
  view: EditorView
  queryClient: QueryClient
  disposers: Array<() => void>

  constructor(view: EditorView) {
    this.view = view

    const { store, queryClient }: State = getTrackChangesState(this.view.state)
    store.setView(this.view)
    this.queryClient = queryClient
    this.disposers = [
      reaction(
        () => store.hideDecorations,
        (_) => {
          this.view.dispatch(this.view.state.tr)
        },
      ),
    ]

    view.dom.addEventListener('blur', this.trackArticleUpdate)
  }

  trackArticleUpdate = () => {
    const { store } = getTrackChangesState(this.view.state)

    if (store.docChanged) {
      store.docStore?.trackArticleUpdate()
      store.setDocChanged(false)
    }
  }

  update(view: EditorView) {
    this.view = view
    const { store } = getTrackChangesState(this.view.state)
    store.setView(this.view)
  }

  destroy() {
    const { store } = getTrackChangesState(this.view.state)
    store.setView(undefined)
    this.disposers.forEach((dispose) => dispose())
    document.removeEventListener('blur', this.trackArticleUpdate)
  }
}
